import Chip from "Components/atoms/chip"
import { FailingCheck, HealthStatus, ProjectHealthUI } from "models/project-health"
import { UncontrolledTooltip } from "reactstrap"

interface HealthStatusChipProps {
    status: HealthStatus | null | undefined
    // When set, hovering the chip lists the checks that caused the status
    failingChecks?: FailingCheck[]
    tooltipId?: string
}

// Status is never colour alone: icon + label + colour.
const HealthStatusChip = ({ status, failingChecks, tooltipId }: HealthStatusChipProps) => {
    if (!status) return <span className="text-muted">—</span>

    // Ids must not start with a digit to be usable as a CSS selector target
    const id = tooltipId ? `health-${tooltipId}` : undefined

    return <>
        <span id={id} style={{ cursor: failingChecks?.length ? "help" : undefined }}>
            <Chip variant={ProjectHealthUI.chipVariant(status)}>
                <i className={`${ProjectHealthUI.icon(status)} me-1`} />
                {ProjectHealthUI.label(status)}
            </Chip>
        </span>
        {
            id && failingChecks && failingChecks.length > 0 &&
            <UncontrolledTooltip target={id} placement="left">
                <div style={{ textAlign: "left" }}>
                    {failingChecks.map(c => (
                        <div key={c.key}>
                            <strong>{c.label}</strong> ({ProjectHealthUI.label(c.status)}): {c.message}
                        </div>
                    ))}
                </div>
            </UncontrolledTooltip>
        }
    </>
}

export default HealthStatusChip
